<template>
  <div class="user-form">
    <el-form label-position="top" label-width="80px" :model="userForm">
      <el-form-item label="用户名">
        <el-input v-model="userForm.username"></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="userForm.mobile"></el-input>
      </el-form-item>
      <el-form-item label="用户等级" v-if="userForm.user_id">
        <el-select v-model="userForm.admin_level" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否激活" v-if="userForm.user_id">
        <el-switch v-model="userForm.is_active"></el-switch>
      </el-form-item>
      <div v-show="updatePwd">
        <div class="el-form-item">
          <label class="el-form-item__label">密码</label>
          <div class="el-input">
            <input type="password" class="el-input__inner" v-model="userForm.password" />
          </div>
        </div>
        <div class="el-form-item">
          <label class="el-form-item__label">重复密码</label>
          <div class="el-input">
            <input type="password" class="el-input__inner" v-model="userForm.repwd" />
          </div>
        </div>
      </div>
      <el-form-item>
        <el-button type="primary" @click="createUser" v-if="!userForm.user_id"
          >创建</el-button
        >
        <el-button
          type="primary"
          @click="updateUser"
          v-else
          :disabled="editDisabled(userForm)"
          >保存</el-button
        >
        <el-button type="primary" @click="resetBtn" v-if="userForm.user_id"
          >重置用户密码</el-button
        >
        <el-button @click="$router.go(-1)">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      options: [{value: 0, label: "普通用户"}, {value: 1, label: "普通管理员"}, {value: 2, label: "超级管理员"}],
      updatePwd: false,
      userForm: {
        username: "",
        mobile: "",
        admin_level: 0,
        is_active: true,
      },
    };
  },
  methods: {
    inputPwd(v) {
      console.log(v);
    },
    editDisabled(userInfo) {
      if (userInfo.is_admin && userInfo.username === "admin") {
        return true;
      }
      return false;
    },
    resetBtn() {
      let that = this;
      that.userForm.password = "";
      that.userForm.repwd = "";
      that.updatePwd = !that.updatePwd;
    },
    updateUser() {
      // 更新用户信息
      let that = this;
      if (that.updatePwd) {
        if (that.userForm.password === "" || that.userForm.repwd === "") {
          that.$message.warning("缺少密码或重复密码");
          return;
        }
        if (that.userForm.password !== that.userForm.repwd) {
          that.$message.warning("两次输入密码不一致");
          return;
        }
      }
      that.$axios
        .put(that.host + "/api/users/admin/users", that.userForm)
        .then((res) => {
          that.$message.success("修改用户信息成功");
          that.$router.go(-1);
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
        });
    },
    createUser() {
      // 添加用户信息
      let that = this;
      that.$axios
        .post(that.host + "/api/users/admin/users", that.userForm)
        .then((res) => {
          that.$message.success("添加用户信息成功");
          that.$router.go(-1);
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
        });
    },
    loadUserDetail(user_id) {
      let that = this;
      that.$axios
        .get(that.host + "/api/users/admin/users?user_id=" + user_id)
        .then((res) => {
          that.userForm = res.data.results;
        })
        .catch((err) => {
          that.$message.error(err.data.errmsg);
        });
    },
  },
  mounted() {
    let that = this;
    let user_id = that.$route.query.user_id;
    if (user_id) {
      that.loadUserDetail(user_id);
    }
  },
};
</script>

<style>
.user-form {
  width: 60%;
  padding: 0 30px 0 30px;
}
</style>
